import { useEffect } from 'react';
import { FolderTree } from 'lucide-react';
import { useDocsStore } from '../../stores/docsStore';
import { FileTreeNode } from './FileTreeNode';
import { Spinner } from '../common/Spinner';
import { EmptyState } from '../common/EmptyState';

export function FileTree() {
  const { tree, treeLoading, fetchTree, fetchRoots } = useDocsStore();

  useEffect(() => {
    fetchRoots();
    fetchTree();
  }, [fetchRoots, fetchTree]);

  if (treeLoading && tree.length === 0) {
    return (
      <div className="flex items-center justify-center py-8">
        <Spinner size="sm" />
      </div>
    );
  }

  if (!treeLoading && tree.length === 0) {
    return (
      <div className="p-4">
        <EmptyState
          icon={<FolderTree />}
          title="No directories found"
          description="Could not load the directory tree from VPS."
        />
      </div>
    );
  }

  return (
    <div className="py-1">
      {tree.map(node => (
        <FileTreeNode key={node.path} node={node} depth={0} />
      ))}
    </div>
  );
}

export default FileTree;
